module.exports = __webpack_public_path__ + "img/arrow_up.ac414e8e.png";